import { useEffect, useState } from 'react';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToBooks = () => {
    const element = document.getElementById('books');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/042ed3958c7daf446aa164f409ce0a4c.jpg"
          alt="Literary Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 flex flex-col md:flex-row items-center justify-between gap-12">

        {/* Left: Text */}
        <div
          className="flex-1 text-left"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateX(0)' : 'translateX(-48px)',
            transition: 'opacity 0.9s ease, transform 0.9s ease',
          }}
        >
          <p className="text-amber-400 uppercase tracking-[0.3em] text-sm font-semibold mb-4">
            Gary Wilson
          </p>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            WE ALL MAKE<br />DECISIONS<span className="text-amber-400">...</span>
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-10 font-light leading-relaxed max-w-lg">
            May Seem Small But They Will Affect You As Minor And Major In Every Way
          </p>
          <button
            onClick={scrollToBooks}
            className="inline-flex items-center px-8 py-4 bg-amber-700 text-white rounded-full text-base font-medium hover:bg-amber-600 transition-all duration-300 hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 bg-amber-600 rounded-full flex items-center justify-center mr-3">
              <i className="ri-book-open-line text-base"></i>
            </span>
            EXPLORE THE BOOK
          </button>
        </div>

        {/* Right: Book Cover */}
        <div
          className="flex-shrink-0 flex items-center justify-center"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateX(0) translateY(0)' : 'translateX(60px)',
            transition: 'opacity 1.1s ease 0.3s, transform 1.1s ease 0.3s',
          }}
        >
          <div
            className="relative"
            style={{ animation: 'floatBook 4s ease-in-out infinite' }}
          >
            {/* Glow behind book */}
            <div
              className="absolute inset-0 rounded-xl"
              style={{
                background: 'radial-gradient(ellipse at center, rgba(217,119,6,0.45) 0%, transparent 70%)',
                filter: 'blur(24px)',
                transform: 'scale(1.15)',
                zIndex: 0,
              }}
            ></div>

            {/* Book image */}
            <div
              className="relative z-10 rounded-xl overflow-hidden shadow-2xl"
              style={{
                width: '360px',
                height: '540px',
                boxShadow: '0 30px 80px rgba(0,0,0,0.7), 0 0 40px rgba(217,119,6,0.3)',
                transform: 'perspective(800px) rotateY(-6deg)',
                transition: 'transform 0.4s ease, box-shadow 0.4s ease',
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLDivElement).style.transform = 'perspective(800px) rotateY(0deg) scale(1.04)';
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 40px 100px rgba(0,0,0,0.8), 0 0 60px rgba(217,119,6,0.5)';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLDivElement).style.transform = 'perspective(800px) rotateY(-6deg)';
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 30px 80px rgba(0,0,0,0.7), 0 0 40px rgba(217,119,6,0.3)';
              }}
            >
              <img
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/c4c9f07f5ee514029f79bb1059f69d8a.jpeg"
                alt="We All Make Decisions Book Cover"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Reflection */}
            <div
              className="relative z-10 mt-1 rounded-b-xl overflow-hidden"
              style={{
                width: '360px',
                height: '60px',
                transform: 'perspective(800px) rotateY(-6deg) scaleY(-1)',
                opacity: 0.18,
                maskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.6), transparent)',
                WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,0.6), transparent)',
              }}
            >
              <img
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/c4c9f07f5ee514029f79bb1059f69d8a.jpeg"
                alt=""
                className="w-full object-cover object-top"
                style={{ height: '420px', marginTop: '-360px' }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>

      {/* Floating keyframe */}
      <style>{`
        @keyframes floatBook {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-14px); }
        }
      `}</style>
    </section>
  );
}
